import React from 'react';
import { Paper, Text, Group, ThemeIcon, rem } from '@mantine/core';
import { IconTrendingUp } from '@tabler/icons-react';

interface StatCardProps {
    label: string;
    value: string;
    trend: string;
    icon: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, trend, icon }) => {
    return (
        <Paper withBorder p="md" radius="md">
            <Group justify="space-between">
                <Text size="xs" c="dimmed" fw={700} tt="uppercase">
                    {label}
                </Text>
                <ThemeIcon variant="light" color="gray">
                    {icon}
                </ThemeIcon>
            </Group>

            <Group align="flex-end" gap="xs" mt={25}>
                <Text fw={700} size={rem(24)} lh={1}>
                    {value}
                </Text>
                <Text c="teal" fz="sm" fw={700} style={{ display: 'flex', alignItems: 'center' }}>
                    <span>{trend}</span>
                    <IconTrendingUp size="1rem" stroke={1.5} style={{ marginLeft: 4 }} />
                </Text>
            </Group>
        </Paper>
    );
};

export default StatCard;
